/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Trust1_NInputs */

const es_landing_trust1_n = /** @type {(inputs: Landing_Trust1_NInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Autorizada`)
};

const gl_landing_trust1_n = /** @type {(inputs: Landing_Trust1_NInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Autorizada`)
};

const en_landing_trust1_n = /** @type {(inputs: Landing_Trust1_NInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Authorised`)
};

/**
* | output |
* | --- |
* | "Authorised" |
*
* @param {Landing_Trust1_NInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const landing_trust1_n = /** @type {((inputs?: Landing_Trust1_NInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Trust1_NInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_landing_trust1_n(inputs)
	if (locale === "en") return en_landing_trust1_n(inputs)
	return es_landing_trust1_n(inputs)
});